import { TMapConstant } from '@metadata';

const key = '48494331-A4C4-380A-9A01-F25957423F15';
const MapConstant: TMapConstant = {
  key,
  type: {
    base: `http://api.vworld.kr/req/wmts/1.0.0/${key}/Base/{z}/{y}/{x}.png`,
    satellite: `http://api.vworld.kr/req/wmts/1.0.0/${key}/Satellite/{z}/{y}/{x}.jpeg`,
  },
  coord_system: [
    {
      type: 'EPSG:4326',
      center: [126.556041, 33.345824],
      extent: [125.6997940517578, 33.05743288671875, 127.41228794824218, 33.63421511328125],
    },
    {
      type: 'EPSG:5179',
      wkt: 'PROJCS["Korea 2000 / Unified CS",GEOGCS["Korea 2000",DATUM["Geocentric_datum_of_Korea",SPHEROID["GRS 1980",6378137,298.257222101],TOWGS84[0,0,0,0,0,0,0]],PRIMEM["Greenwich",0,AUTHORITY["EPSG","8901"]],UNIT["degree",0.0174532925199433,AUTHORITY["EPSG","9122"]],AUTHORITY["EPSG","4737"]],PROJECTION["Transverse_Mercator"],PARAMETER["latitude_of_origin",38],PARAMETER["central_meridian",127.5],PARAMETER["scale_factor",0.9996],PARAMETER["false_easting",1000000],PARAMETER["false_northing",2000000],UNIT["metre",1,AUTHORITY["EPSG","9001"]],AUTHORITY["EPSG","5179"]]',
      center: [961948.6633591041, 1831438.458010095],
      extent: [858717.3006772982, 1453668.2322360696, 965609.3459643911, 1514749.4009715514],
    },
  ],
};

export default MapConstant;
